import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55112382"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bar",
  style: {"width":"100%"}
}, null, -1))
const _hoisted_3 = { class: "bar-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["aria-valuenow"]
const _hoisted_6 = { class: "bar-text" }
const _hoisted_7 = {
  key: 1,
  class: "traffic-plain"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["aria-valuenow"]
const _hoisted_10 = { class: "bar-text" }
const _hoisted_11 = ["aria-valuenow"]
const _hoisted_12 = { class: "bar-text" }
const _hoisted_13 = ["aria-valuenow"]
const _hoisted_14 = { class: "bar-text" }
const _hoisted_15 = { class: "expandRow" }
const _hoisted_16 = { colspan: "12" }
const _hoisted_17 = { id: "expand_mem" }
const _hoisted_18 = { id: "expand_swap" }
const _hoisted_19 = { id: "expand_hdd" }
const _hoisted_20 = {
  key: 0,
  id: "expand_traffic"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: "tableRow",
      tabindex: "0",
      "aria-expanded": !_ctx.collapsed,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsed = !_ctx.collapsed)),
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.collapsed = !_ctx.collapsed), ["prevent"]), ["enter"])),
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.collapsed = !_ctx.collapsed), ["prevent"]), ["space"]))
      ]
    }, [
      _createElementVNode("td", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["ui progress", {'success': _ctx.getStatus, 'error': !_ctx.getStatus}])
        }, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getStatus ? '运行中' : '维护中'), 1)
        ], 2)
      ]),
      _createElementVNode("td", null, [
        _createTextVNode(_toDisplayString(_ctx.server.name), 1),
        _createElementVNode("span", {
          class: _normalizeClass(["row-chevron", { open: !_ctx.collapsed }]),
          "aria-hidden": "true"
        }, "▾", 2)
      ]),
      _createElementVNode("td", null, _toDisplayString(_ctx.server.type), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.server.location), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.server.uptime || '–'), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.getStatus ? _ctx.server.load : '-'), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.getStatus ? `${_ctx.tableRowByteConvert(_ctx.server.network_rx)} | ${_ctx.tableRowByteConvert(_ctx.server.network_tx)}` : '–'), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.getStatus ? `${_ctx.tableRowByteConvert(_ctx.server.network_in)} | ${_ctx.tableRowByteConvert(_ctx.server.network_out)}` : '–'), 1),
      (_ctx.trafficEnabled)
        ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
            (_ctx.traffic.limited)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["ui progress traffic-progress", _ctx.traffic.level]),
                  role: "progressbar",
                  "aria-label": "本月流量用量",
                  "aria-valuenow": _ctx.traffic.percent,
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "bar",
                    style: _normalizeStyle({'width': `${_ctx.traffic.percent}%`})
                  }, null, 4),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.traffic.state === 'offline'
              ? '维护中'
              : `${_ctx.tableRowByteConvert(_ctx.traffic.used)} / ${_ctx.tableRowByteConvert(_ctx.traffic.limit)}`), 1)
                ], 10, _hoisted_5))
              : (_ctx.traffic.tracked)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.traffic.state === 'offline' ? '维护中' : _ctx.tableRowByteConvert(_ctx.traffic.used)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "–"))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("td", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(_ctx.getCpuStatus)]),
          role: "progressbar",
          "aria-label": "CPU 使用率",
          "aria-valuenow": _ctx.getCpuStatus,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, [
          _createElementVNode("div", {
            class: "bar",
            style: _normalizeStyle({'width': `${_ctx.getCpuStatus.toString()}%`})
          }, null, 4),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getStatus ? `${_ctx.getCpuStatus.toString()}%` : '维护中'), 1)
        ], 10, _hoisted_9)
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(_ctx.getRAMStatus)]),
          role: "progressbar",
          "aria-label": "内存使用率",
          "aria-valuenow": _ctx.getRAMStatus,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, [
          _createElementVNode("div", {
            class: "bar",
            style: _normalizeStyle({'width': `${_ctx.getRAMStatus.toString()}%`})
          }, null, 4),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getStatus ? `${_ctx.getRAMStatus.toString()}%` : '维护中'), 1)
        ], 10, _hoisted_11)
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["ui progress", _ctx.getProcessBarStatus(_ctx.getHDDStatus)]),
          role: "progressbar",
          "aria-label": "硬盘使用率",
          "aria-valuenow": _ctx.getHDDStatus,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, [
          _createElementVNode("div", {
            class: "bar",
            style: _normalizeStyle({'width': `${_ctx.getHDDStatus.toString()}%`})
          }, null, 4),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getStatus ? `${_ctx.getHDDStatus.toString()}%` : '维护中'), 1)
        ], 10, _hoisted_13)
      ])
    ], 40, _hoisted_1),
    _createElementVNode("tr", _hoisted_15, [
      _createElementVNode("td", _hoisted_16, [
        _createElementVNode("div", {
          class: _normalizeClass({collapsed: _ctx.collapsed}),
          style: _normalizeStyle({'max-height': _ctx.getStatus ? '' : '0'})
        }, [
          _createElementVNode("div", _hoisted_17, "内存信息: " + _toDisplayString(_ctx.getStatus ? `${_ctx.expandRowByteConvert(_ctx.server.memory_used * 1024)} / ${_ctx.expandRowByteConvert(_ctx.server.memory_total * 1024)}` : '–'), 1),
          _createElementVNode("div", _hoisted_18, "交换分区: " + _toDisplayString(_ctx.getStatus ? `${_ctx.expandRowByteConvert(_ctx.server.swap_used * 1024)} / ${_ctx.expandRowByteConvert(_ctx.server.swap_total * 1024)}` : '–'), 1),
          _createElementVNode("div", _hoisted_19, "硬盘信息: " + _toDisplayString(_ctx.getStatus ? `${_ctx.expandRowByteConvert(_ctx.server.hdd_used * 1024 * 1024)} / ${_ctx.expandRowByteConvert(_ctx.server.hdd_total * 1024 * 1024)}` : '–'), 1),
          (_ctx.traffic.tracked)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "月流量: " + _toDisplayString(_ctx.trafficDetail), 1))
            : _createCommentVNode("", true)
        ], 6)
      ])
    ])
  ], 64))
}